module.exports = __webpack_public_path__ + "static/media/icon_arrow.d9b01fd7.svg";